import { gql } from 'graphql-request';

export const GET_TEMPLATE_SHIPMENT_REPORT = gql`
  query App5182dd71_Document {
    app5182dd71_ShipmentReport {
      getTemplate {
        template {
          step
          name
          type
          value
          required
          disabled
          isVisibleDependency
          isSearchable
          optionsDependency
          placeholder
          fieldTransform
          fieldType
          label {
            en
            ru
          }
          stepLabel
          validation
          options {
            label
            value
          }
        }
      }
    }
  }
`;
